import {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {useSelector} from "react-redux";
import BreadcrumbLayout
  from "@/components/common/CustomLayout/BreadcrumbLayout";
import BookingInsightFilter from "@/pages/Report/BookingInsightFilter";
import {getUserVenues} from "@/store/user-info/action";
import {RootState, useAppDispatch} from "@/store";
import {getBookingInsights} from "@/store/booking-insight/action";
import {bookingInsightType, bookingResults} from "@/pages/Report/constant";

const BookingInsight = () => {
  const dispatch = useAppDispatch()
  const [filter, setFilters] = useSearchParams()
  const defaultInsightType = filter.get('insightType') ?? bookingInsightType.BOOKING_TIMES
  const venues = useSelector((state: RootState) => state.userInfo.state.venues)
  const [insightType, setInsightType] = useState(defaultInsightType)

  const handleUpdate = (parameter: UpdateParamObject) => {
    setInsightType(parameter.insightType)
    const params = {
      ...parameter,
      insightType: parameter.insightType
    }
    setFilters(params)
    dispatch(getBookingInsights({params}))
  }

  const currentComponent = () => {
    const Component = bookingResults[insightType]
    return (
      <>
        {
          Component && <Component/>
        }
      </>
    )
  }

  useEffect(() => {
    dispatch(getUserVenues({}))
  }, [])

  return (
    <BreadcrumbLayout>
      {
        venues.length ?
        <div className="w-full flex flex-col gap-7">
          <div className="page-title">Booking Insight</div>
          <div className="report-wrapper">
            <div>
              <BookingInsightFilter handleUpdate={handleUpdate}/>
            </div>
            {currentComponent()}
          </div>
        </div> : <></>
      }
    </BreadcrumbLayout>
  )

}
export default BookingInsight;